<template>
  <div class="home">
    <Navbar @cor="tema($event)" @traduzir="traduz($event)" />

    <Slides :cor="cor" :traduzir="traduzir" />

    <Sobre :cor="cor" :traduzir="traduzir" />

    <Beneficios :cor="cor" :traduzir="traduzir" />

    <Formulario :cor="cor" :traduzir="traduzir" />

    <Contato :cor="cor" :traduzir="traduzir" />

    <Direitos :cor="cor" :traduzir="traduzir" />
  </div>
</template>

<script>
import { useUsuarioStore } from '../stores/autenticacao'; //pinia cookie do navegador

import Navbar from '@/components/Navbar.vue';
import Contato from '@/components/Contato.vue';
import Slides from '@/components/Slides.vue';
import Sobre from '@/components/Sobre.vue';
import Beneficios from '@/components/Beneficios.vue';
import Formulario from '@/components/Formulario.vue';
import Direitos from '@/components/Direitos.vue';


export default {
  name: 'Home',

  data(){
    return{
      cor: false,
      traduzir: false,
    }
  },

  created(){
      this.atualiza()
  },

  components: {
    Navbar,
    Contato,
    Slides,
    Sobre,
    Beneficios,
    Formulario,
    Direitos
  },

  methods: {
    atualiza(){
        const store = useUsuarioStore();

        this.traduzir = store.portugues;
        this.cor = store.diurno;
    },

    traduz(dado){
      //console.log(dado);
      this.traduzir = dado.traduzir;
      //console.log(this.traduzir);
    },

    tema(dado){
      this.cor = dado.cor;
    }
  }
}
</script>
